<!-- 弹窗  -->
<template>
    <div class="dialog">
        <van-overlay class="overlay" :show="show" @click="hideDialog" :z-index="999" v-bind="$attrs">
            <div class="dialog-wrapper" @click.stop>
                <div v-if="isTitle" class="dialog-container">
                    <div class="dialog-header">
                        <!-- 订单申诉 -->
                        <div class="dialog-header-title">
                            <slot name="title"></slot>
                        </div>
                        <div @click="hideDialog">
                            <img src="@/assets/images/cloose.png" alt="" />
                        </div>
                    </div>
                    <div class="line"></div>
                </div>

                <slot name="content"></slot>

                <div class="dialog-wrapper-btn flex justify-between">
                    <van-button class="dialog-wrapper-btn-item" v-debounce="handleLeftBtn" :plain="plainType">{{ leftBtnText }}</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "DialogSlot",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: String,
        //是否需要title
        isTitle: {
            type: Boolean,
            default: false,
        },

        plainType: {
            type: Boolean,
            default: false,
        },
        leftBtnText: String,
        rightBtnText: String,
    },
    data() {
        return {};
    },
    methods: {
        handleShowDialog() {
            this.$emit("update:show");
        },
        hideDialog() {
            this.$emit("update:show", false);
        },
        handleLeftBtn() {
            this.$emit("handleLeftBtn");
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
    },
};
</script>

<style lang="less" scoped>
.dialog {
    z-index: 2100;
    .overlay {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .dialog-wrapper {
        width: 599px;
        min-height: 319px;
        background: #ffffff;
        border-radius: 20px;

        .dialog-content {
            padding: 20px;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #212121;
            line-height: 36px;
            text-align: center;
            margin: 80px 0;
        }
        .dialog-wrapper-btn {
            width: 100%;
            padding: 0 32px;
            margin-bottom: 20px;
            .dialog-wrapper-btn-item {
                width: 100%;
                height: 70px;
                border-radius: 16px;
                font-size: 32px;
                color: #fff;
                background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            }
        }
    }
}
.dialog-header {
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    height: 106px;
    align-items: center;
    .dialog-header-title {
        font-size: 28px;
    }

    img {
        height: 28px;
        width: 28px;
    }
}
.dialog-bottom {
    padding: 0 32px;
    .dialog-bottom-title {
        margin-top: 20px;
        font-size: 28px;
    }
}

.line {
    width: 90%;
    margin: 0 auto;
    border-bottom: 0.5px #dbdada solid;
}
</style>
